<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      ref="crud"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddForm('add')"
          >新 增
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <!--        <el-button type="text" size="small" @click="toView(scope.row)">
          <span class="el-icon-view"></span>查看
        </el-button>-->
        <el-button type="text" size="small" icon="el-icon-edit" @click="toEdit(scope.row, 'edit')"
          >编辑</el-button
        >
      </template>
    </avue-crud>
    <avue-form
      v-if="showForm"
      ref="parkRegionForm"
      v-model="form"
      :rules="rules"
      :option="option"
      @reset-change="emptyChange"
      @submit="submit"
    >
      <template slot-scope="scope" slot="menuForm">
        <el-button @click="emptyChange" icon="el-icon-delete">清空</el-button>
      </template>
    </avue-form>
  </basic-container>
</template>

<script>
import {
  getRegionList,
  numberCheck,
  stringCheck,
  getPassages,
} from '@/views/v4ward/carv2/merge/api/park-merge';
import { update, addParkSpaceNode } from '@/api/v4ward/carv2/carpark';
import { mapGetters } from 'vuex';
export default {
  props: {
    parkSpace: {},
  },
  data() {
    return {
      loading: false,
      showForm: false,
      operateType: '',
      form: {},
      option: {
        calcHeight: 350,
        tip: false,
        border: true,
        index: false,
        selection: false,
        columnBtn: false,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menuType: 'text',
        refreshBtn: false,
        emptyBtn: false,
        align: 'center',
        menuWidth: 100,
        column: [
          {
            label: '区域名称',
            prop: 'spaceName',
            rules: [
              {
                required: true,
                trigger: 'blur',
                message: '请输入区域名称',
              },
              {
                validator: stringCheck,
                min: 2,
                max: 10,
                trigger: 'blur',
              },
            ],
          },
          {
            label: '上级节点',
            prop: 'parentId',
            type: 'tree',
            props: {
              label: 'title',
              value: 'key',
            },
            rules: [
              {
                required: true,
                message: '请选择上级节点',
                trigger: 'blur',
              },
            ],
            dicUrl: '/api/v4ward/carv2/ParkSpace/merge/regionParentNodes?id=' + this.parkSpace.id,
          },
          {
            label: '车位数',
            prop: 'parkLotNumber',
            type: 'number',
            rules: [
              {
                required: true,
                message: '请输入车位数',
                trigger: 'blur',
              },
              {
                validator: numberCheck,
                min: 10,
                max: 10000,
                trigger: 'blur',
              },
            ],
          },
          {
            label: '临停车位',
            prop: 'tempParkFlag',
            type: 'select',
            dicData: [
              { label: '是', value: '0' },
              { label: '否', value: '1' },
            ],
            rules: [
              {
                required: true,
                message: '请选择临停车位',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '状态',
            prop: 'carParkStatus',
            type: 'select',
            dataType: 'number',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_park_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择车位状态',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '单独计费',
            prop: 'carParkAreaType',
            type: 'select',
            dataType: 'number',
            dicUrl: '/api/blade-system/dict/dictionary?code=park_area_fee_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择是否单独计费',
                trigger: 'blur',
              },
            ],
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkpassage_add, false),
      };
    },
    ids() {
      /* let ids = [];
        this.selectionList.forEach((ele) => {
          ids.push(ele.id);
        });
        return ids.join(',');*/
    },
  },
  created() {
    setTimeout(() => {
      document.querySelector('#pane-parkRegion > div > div > div').style =
        'padding-top:0px !important';
      document.querySelector(
        '#pane-parkRegion > div > div > div > div.avue-crud > div.avue-crud__pagination'
      ).style = 'padding-top:0px !important';
    });
  },
  mounted() {},
  methods: {
    openAddForm(operateType) {
      this.operateType = operateType;
      this.cleanForm();
      this.showForm = !this.showForm;
    },
    toEdit(row, operateType) {
      this.operateType = operateType;
      this.showForm = !this.showForm;
      this.form = row;
    },
    onLoad() {
      this.loading = true;
      getRegionList({ parkId: this.parkSpace.id, spaceName: this.spaceName, type: 3 }).then(
        (data) => {
          this.data = data.data;
          this.loading = false;
        }
      );
    },
    emptyChange() {
      if (this.operateType === 'add') {
        this.cleanForm();
      } else {
        this.$message.warning('编辑时清空无效！');
      }
    },
    submit(form, done) {
      if (this.vdui.isEmpty(form.id)) {
        this.form.parkingLotId = this.parkSpace.id;
        addParkSpaceNode(this.form).then(
          () => {
            done();
            this.$message.success('操作成功!');
            this.cleanForm();
            this.onLoad();
            this.showForm = false;
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      } else {
        update(this.form).then(
          () => {
            done();
            this.$message.success('操作成功!');
            this.cleanForm();
            this.onLoad();
            this.showForm = false;
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      }
    },
    cleanForm() {
      for (let key in this.form) {
        this.form[key] = '';
      }
    },
  },
};
</script>
<style scoped></style>
